import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { catchError, finalize, of, tap } from 'rxjs';

interface TokenData {
  accessToken: string
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticatorService {

  private api = inject(ApiService)
  private deviceId = this.initDevice()
  private _accessToken?: string

  get isAuthed() {
    return Boolean(this._accessToken)
  }

  get accessToken() {
    if (this._accessToken) {
      return this._accessToken
    }
    throw new Error('Access token not set')
  }

  init() {
    // Для silent-авторизации нужен префикс /client/self, чтобы ушли SSO-cookies
    return this.api.get<TokenData>('/client/self/oauth/v2/silent', {
      device_id: this.deviceId
    }).pipe(
      tap(data => this._accessToken = data.accessToken),
      catchError(() => of(undefined))
    )
  }

  logout() {
    // Выход должен идти через /client/self, чтобы очистить SSO-сессию
    return this.api.get('/client/self/oauth/v2/logout').pipe(
      finalize(() => this._accessToken = undefined)
    )
  }

  private initDevice() {
    let deviceId = localStorage.getItem('id_system_device_id')
    if (!deviceId) {
      deviceId = crypto.randomUUID()
      localStorage.setItem('id_system_device_id', deviceId)
    }
    return deviceId
  }

}
